import React, { useState } from 'react';
import { makeStyles } from '@material-ui/core/styles';
import Checkbox from '@material-ui/core/Checkbox';
import ChartProgressionData from '../charts/ChartProgressionData';
import ChartStrategyExecData from '../charts/ChartStrategyExecData';
import CollapseContainer from './CollapseContainer';

const useStyles = makeStyles((theme) => ({
  container: {
    maxWidth: 1280,
    margin: '0 auto'
  },
  chartsContainer: {
    display: 'flex',
    alignItems: 'center',
    justifyContent: 'center'
  },
  title: {
    marginTop: 20,
    fontSize: 22,
    textAlign: 'left'
  },
  filters: {
    display: 'flex',
    alignItems: 'center'
  }
}));

const FeedBackSynthesis = () => {
  const [state, setState] = useState({
    opinionLead: true,
    tier1: true,
    tier2: true
  });
  const classes = useStyles();

  const handleChangeCheck = (e) => {
    const { checked } = e.target;
    const { name } = e.target;
    console.log(name, e);
    setState({
      ...state,
      [name]: checked
    });
  };

  return (
    <div className={classes.container}>
      <CollapseContainer>
        <h3 className={classes.title}>Summary of feedbacks</h3>
        <div className={classes.filters}>
          <h3>Filters:</h3>
          <Checkbox
            checked={state.opinionLead}
            color="primary"
            name="opinionLead"
            onChange={handleChangeCheck}
          />
          Opinion leaders
          <Checkbox
            checked={state.tier1}
            color="primary"
            name="tier1"
            onChange={handleChangeCheck}
          />
          Tier 1
          <Checkbox
            checked={state.tier2}
            color="primary"
            name="tier2"
            onChange={handleChangeCheck}
          />
          Tier 2
        </div>
        <div className={classes.chartsContainer}>
          <ChartProgressionData />
          <ChartStrategyExecData
            dataProp="dataStrategyExecution"
            id="id-charexec-1"
            title="EXECUTION OF STRATEGY"
          />
          <ChartStrategyExecData
            dataProp="dataStrategyExecution2"
            id="id-charexec-2"
            title="FINANCIAL EXPOSITION"
          />
        </div>
      </CollapseContainer>
    </div>
  );
};

export default FeedBackSynthesis;
